// 我的
export default [{
  path: '/psychologicalHotline',
  name: 'psychologicalHotline',
  component: resolve => require(['@/views/psychologicalHotline/psychologicalHotline.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/psychologicalHotline/psychologicalHotline.js